import { JsonLd, MetaData, ServicePage } from '@/components'
import { useHost } from '@/contexts/HostContext'
import { buildServiceSchemas } from '@/lib/schema'
import { getCanonicalUrl } from '@/lib/locales'
import { getRouteLocale, resolveServiceRoute, sendPermanentRedirect } from '@/lib/resolveServiceCanonical'
import { slimServicePayload } from '@/lib/stripUnrenderedDirectionImages'
import { useRouter } from 'next/router'

export default function NextServicePage(props) {
  const { meta = {}, canonicalPath } = props
  const { title: titleFromProps, description: descFromProps } = meta
  const title = titleFromProps || props.title
  const description = descFromProps || props.description
  const host = useHost()
  const router = useRouter()
  const pageUrl = getCanonicalUrl(canonicalPath || router?.asPath || '/', host)
  const serviceSchema = buildServiceSchemas(props, {
    host,
    asPath: canonicalPath || router?.asPath,
    pageUrl,
  })
  return (
    <>
      <MetaData title={title} description={description} />
      <JsonLd data={serviceSchema} />
      <ServicePage {...props} />
    </>
  )
}

NextServicePage.getInitialProps = async ({ query, api, req, res, asPath }) => {
  const { serviceSlug, typeSlug, ...otherQueries } = query

  const response = await api.service({ slug: serviceSlug, ...otherQueries })
  const { data } = response
  const { canonicalPath, redirectTo } = resolveServiceRoute({
    typeSlug,
    service: data,
    locale: getRouteLocale(req, asPath),
  })

  if (redirectTo) {
    sendPermanentRedirect(res, redirectTo)
    return {}
  }

  return { ...slimServicePayload(data), pageType: 'service', canonicalPath }
}
